import React, { FC, useMemo } from 'react';
import { Alert, Button, Card, CardBody, Collapse, Input } from 'reactstrap';
import { useTranslation } from '../../../../translations';
import { useToggle } from '../../../../utils';

export const KeyView: FC<{ readonly value: object | null }> = ({ value }) => {
  const [isOpen, toggle] = useToggle(false);
  const keyStr = useMemo(() => {
    if (!value) {
      return null;
    }

    return JSON.stringify(value, null, 2);
  }, [value]);

  const { ts } = useTranslation();

  if (!keyStr) {
    return null;
  }

  return (
    <>
      <Button color="primary" onClick={toggle} style={{ marginBottom: '1rem' }}>
        {ts('view_verification_key')}
      </Button>
      <Collapse isOpen={isOpen}>
        <Card>
          <CardBody>
            <Alert color="warning">
              {ts('use_this_public_key')}
              <br />
              {/* eslint-disable-next-line react/jsx-no-literals */}
              {ts('you_should_retrieve_and_cache')} <code>/.well-known/jwks.json</code>.{' '}
              {ts('for_more_details')} {/* eslint-disable-next-line react/jsx-no-literals */}
              <a href="https://jwt.io/" referrerPolicy="no-referrer">
                jwt.io
              </a>
            </Alert>
            <Input defaultValue={keyStr} readOnly style={{ height: '150px' }} type="textarea" />
          </CardBody>
        </Card>
      </Collapse>
    </>
  );
};
